import React from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'

import { settings } from '../helpers/UtilsHelper';

//import useAuth from '../auth/useAuth';

import About from '../components/home/About'
import Accounts from '../components/accounts/Accounts';
import AccountDetails from '../components/accounts/AccountDetails';
import Bots from '../components/bots/Bots';
import BotEdit from '../components/bots/BotEdit';
import Contact from '../components/home/Contact'
import Footer from '../components/main/Footer';
import Header from '../components/main/Header'
import Home from '../components/home/Home'

import Login from '../components/login/Login'
import ForgotPassword from '../components/login/ForgotPassword';

import Privacy from '../components/home/Privacy'
//import Menu from '../components/main/Menu'
import NotFound from '../components/home/NotFound';
import PrivateRoute from './PrivateRoute';
import Process from '../components/items/Process';
//import Rates from '../components/rates/Rates';
import RegisterNewUser from '../components/login/RegisterNewUser';
import RegistrationStatus from '../components/login/RegistrationStatus';
import Users from '../components/users/Users';
import UserCode from '../components/mercadoLibre/UserCode';
import Profile from '../components/users/Profile';
import NotificationsToast from '../components/notificationsToast/NotificationsToast';
import PublicRoute from './PublicRouter';
import Rates from '../components/rates/Rates';
import Sales from '../components/sales/Sales';

//#region Mercado libre
import MlCategories from '../components/mercadoLibre/MlCategories';
import MlSites from '../components/mercadoLibre/MlSites';
import AdvancedCommand from '../components/advancedCommand/AdvancedCommand';
import ArtificialIntelligence from '../components/artificialIntelligence/ArtificialIntelligence';
import ArtificialIntelligenceEdit from '../components/artificialIntelligence/ArtificialIntelligenceEdit';
import Roles from '../components/roles/Roles';
import LargeLanguageModel from '../components/largeLanguageModels/LargeLanguageModels';
import LlmModels from '../components/largeLanguageModels/LlmModels';
import UserLlmModelSelect from '../components/largeLanguageModels/UserLlmModelSelect';
//#endregion Mercado libre

//import { checkIfUserIsAdmin } from '../helpers/UtilsHelper';

const { app } = settings;
const { urls } = app?.backend;

export default function AppRouter() {
    return (
        <Router>
            {/* Preloader */}
            <div className='preloader flex-column justify-content-center align-items-center'>
                <img className='animation__shake' src={settings?.images?.appLogo} alt='appLogo' height={100} width={150} />
            </div>

            <Header />
            {/* <MenuLeft /> */}
            <Switch>
                {/* Home */}
                <Route exact path='/' component={Home} />
                <Route exact path={urls?.home} component={Home} />
                <Route exact path={urls?.about} component={About} />
                <Route exact path={urls?.contact} component={Contact} />
                <Route exact path={urls?.privacy} component={Privacy} />
                <Route path='/userCode' component={UserCode} />

                {/* Accounts */}
                <PrivateRoute exact path={urls?.accounts} component={Accounts} />

                {/*Advanced commands*/}
                <PrivateRoute exact path={urls?.advancedCommands} component={AdvancedCommand} />

                {/*Artificial intelligence*/}
                <PrivateRoute exact path={urls?.ai} component={ArtificialIntelligence} />
                <PrivateRoute path={`${urls?.aiEdit}/:id`} component={ArtificialIntelligenceEdit} />

                {/* Bots */}
                <PrivateRoute exact path={urls?.bots} component={Bots} />
                <PrivateRoute path={`${urls?.botEdit}/:id`} component={BotEdit} />

                {/* <Route path='/accountDetails/:userId' component={AccountDetails}/> */}
                <PrivateRoute path='/accountDetails/:id' component={AccountDetails} />

                {/*Large language model*/}
                <PrivateRoute exact path={urls?.largeLanguageModels} component={LargeLanguageModel} />
                <PrivateRoute exact path={urls?.llmModels} component={LlmModels} />

                {/* Login */}
                <PublicRoute exact path={urls?.login} component={Login} />
                <PublicRoute exact path={urls?.forgotPassword} component={ForgotPassword} />
                <PublicRoute exact path={urls?.registerNewUser} component={RegisterNewUser} />
                <PublicRoute exact path={urls?.registerStatus} component={RegistrationStatus} />

                {/* Items */}
                <PrivateRoute exact path={urls?.process} component={Process} />

                {/* Rates */}
                <PrivateRoute exact path={urls?.rates} component={Rates} />

                {/* Sales */}
                <PrivateRoute exact path={urls?.sales} component={Sales} />

                {/* Users */}
                <PrivateRoute exact path={urls?.users} component={Users} />
                <PrivateRoute exact path={urls?.profile} component={Profile} />

                {/* Notifications Toasts */}
                <PrivateRoute exact path={urls?.notificationToasts} component={NotificationsToast} />

                {/* Mercado Libre */}
                <PrivateRoute exact path={urls?.mlCategories} component={MlCategories} />
                <PrivateRoute exact path={urls?.mlSites} component={MlSites} />
                <PrivateRoute exact path={urls?.userLlmModelSelects} component={UserLlmModelSelect} />

                {/* Roles */}
                <PrivateRoute exact path={urls?.roles} component={Roles} />

                {/* Not found */}
                <Route path='*' component={NotFound} />

            </Switch>
            <Footer />
        </Router>
    )
}